import { call, put, takeLatest } from "redux-saga/effects";
import toast from "react-hot-toast";
import * as types from "../actions/actionTypes";
import {
  axiosGet,
  axiosPost,
  axiosPut,
  axiosDelete,
} from "../../utils/common/axios";
import { getAllStatesResponse, getStateByIdResponse } from "../actions";

export function* createStateEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosPost(`state`, action.data?.payload));
    action.data?.callback?.success?.(data);
    toast.success(data?.message || "State saved successfully");
  } catch (e) {
    console.log(e);
    if (e?.status !== 401) action.data?.callback?.failure?.(e);
  }
}

export function* updateStateEffectSaga(action) {
console.log(action?.data?.payload, "sagastate")
  try {
    const { data } = yield call(() =>
      axiosPut(`state/${action?.data?.payload?.id}`, action.data?.payload)
    );
    action.data?.callback?.success?.(data);
    toast.success(data?.message || "State updated successfully");
  } catch (e) {
    console.log(e);
    if (e?.status !== 401) action.data?.callback?.failure?.(e);
  }
}

export function* getAllStatesEffectSaga(action) {
  try {
    const { status, data } = yield call(() => axiosGet(`state/all`));
    if (status === 200) {
      yield put(getAllStatesResponse(data));
      action?.payload?.callback?.success?.(data);
    }
  } catch (e) {
    console.log(e);
    yield put(getAllStatesResponse([]));
  }
}

export function* getStateByIdEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosGet(`state/${action?.payload?.id}`));
    yield put(getStateByIdResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getStateByIdResponse([]));
  }
}

export function* deleteStateEffectSaga(action) {
  try {
    const { data } = yield call(() =>
      axiosDelete(`state/${action?.payload?.id}`)
    );
    action.payload?.callback?.success?.(data);
    toast.success(data?.message || "State deleted successfully");
  } catch (e) {
    console.log(e);
    if (e?.status !== 401) action.payload?.callback?.failure?.(e);
  }
}

export function* stateWatcherSaga() {
  yield takeLatest(types.CREATE_STATE, createStateEffectSaga);
  yield takeLatest(types.UPDATE_STATE, updateStateEffectSaga);
  yield takeLatest(types.GET_ALL_STATE, getAllStatesEffectSaga);
  yield takeLatest(types.GET_STATE, getStateByIdEffectSaga);
  yield takeLatest(types.DELETE_STATE, deleteStateEffectSaga);
}
